import React from 'react';

import logo from '../../assets/logo.png';
import './styles.css';

function Header() {
  return (
    <header>
      <div className="container">
        <div className="logo">
          <img src={logo} alt="Amparo"/>
        </div>
      </div>
    </header>
  );
}

export default Header;